/**
 * TicketFlow-admin — aiguillage de haut niveau.
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * Non authentifié → Login. `mustChangePassword` (A4) → écran bloquant de
 * changement. Sinon → coquille d'admin pilotée par le schéma.
 *
 * Le schéma d'édition est FOURNI PAR LE SERVEUR (`GET /api/config/schema`, source
 * unique — on ne le duplique pas côté client) ; le schéma local ne sert que de
 * repli hors-ligne / premier rendu.
 */
import React, { useEffect, useState } from 'react';
import { useAuth } from './ui/AuthProvider';
import Login from './ui/screens/Login';
import ForcePasswordChange from './ui/screens/ForcePasswordChange';
import AdminShell from './ui/AdminShell';
import { ticketflowAdminSchema } from './ticketflow/adminSchema';

export default function App({ onServerChange, centralMode = false, siteLabel = '', siteId = '' }) {
  const { isAuthenticated, mustChangePassword, booting, api } = useAuth();
  const [schema, setSchema] = useState(ticketflowAdminSchema); // repli

  useEffect(() => {
    let alive = true;
    api.getSchema().then((s) => { if (alive && s?.sections) setSchema(s); }).catch(() => {});
    return () => { alive = false; };
  }, [api]);

  if (booting) return <div className="centered"><p className="muted">…</p></div>;
  if (!isAuthenticated) return <Login onServerChange={onServerChange} centralMode={centralMode} siteLabel={siteLabel} />;
  if (mustChangePassword) return <ForcePasswordChange />;
  // En mode central, on passe l'id/nom du site pour l'onglet « 📺 Écrans »
  // (approbation signée, appels same-origin vers la console — cf. DisplaysApproval).
  return <AdminShell schema={schema} centralSiteId={centralMode ? siteId : ''} centralSiteName={siteLabel} />;
}
